/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Card_DesignerInputs */



/**
* | output |
* | --- |
* | "Card designer" |
*
* @param {Nav_Card_DesignerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_card_designer = /** @type {((inputs?: Nav_Card_DesignerInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Card_DesignerInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kartendesigner")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créateur de cartes")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("卡牌设计器")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("卡牌設計器")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드 디자이너")
	return /** @type {LocalizedString} */ ("Card designer")
});